import { useEffect, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/AddRounded';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import PopoverComponent from './PopoverComponent';

export default function ImportInfluencerButton({
  showOnboarding,
  onboardingData,
  isExpanded,
  isUserOnPreservationPlan,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (showOnboarding) {
      setAnchorEl(buttonRef.current);
    }
  }, [showOnboarding]);

  return (
    <>
      <CustomTooltip placement="right" title="Import Creators" show={!isExpanded}>
        <ButtonComponent
          onClick={() => {
            if (!isUserOnPreservationPlan) {
              navigate('/dashboard/list?showimportlist=true');
            }
          }}
          ref={buttonRef}
          style={{
            zIndex: 999,
            width: '100%',
            marginBottom: '20px',
            fontSize: '13px',
            borderRadius: '16px',
            padding: isExpanded ? '6px 12px 6px 8px' : '10px 8px 10px 8px',
            backgroundColor: isUserOnPreservationPlan && '#BF9CF433',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
          }}>
          <AddIcon
            fontSize="large"
            sx={{
              strokeWidth: '2',
            }}
          />
          {isExpanded && 'Import Creators'}
        </ButtonComponent>
      </CustomTooltip>

      <PopoverComponent anchorEl={anchorEl} setAnchorEl={setAnchorEl} onboardingData={onboardingData} />
    </>
  );
}
